export default __webpack_public_path__ + "static/media/other-default.da62b50e.svg";